import { combineReducers } from 'redux'
import listReducer, { listActions } from '@app-store/slices/chatDetails/list'
import chatLoginReducer, { chatLoginActions } from '@app-store/slices/chatDetails/login'

export const chatDetailsReducer = combineReducers({
    list: listReducer,
    login: chatLoginReducer
})

export const chatDetailsActions = {
    list: listActions,
    login: chatLoginActions
}
